import angular from 'angular';
import moment from 'moment';

import templateUrl from './rogers-tsu-report.component.html';
import { containsInvariant } from '../../../core/services/filter-util';

export const RogersTsuReportComponent = {
    controller: RogersTsuReportController,
    controllerAs: "vm",
    templateUrl,
    bindings: {
        report: "<",
        reportHeaders: "<",
        headerTotals: "<",
        reportType: "<",
        reportTotals: "<",
        isOwnerView: "<"
    }
};

function RogersTsuReportController() {
    'ngInject';
    const vm = this;
    vm.$onInit = onInit;
    vm.$onChanges = onChanges;
    vm.filters = {};
    vm.onChangeFilter = onChangeFilter;
    vm.pageNumber = 1;
    vm.pageSize = 10;

    function onInit() {


    }

    function onChanges(changes) {
        if (changes.report) {
            vm.filteredReport = vm.report.filter(filterTsuReport);
            calculateTotals();
        }
    }

    function onChangeFilter() {
        vm.pageNumber = 1;
        vm.filteredReport = angular.copy(vm.report);
        vm.filteredReport = vm.filteredReport.filter(filterTsuReport);
        calculateTotals();
    }

    function calculateTotals() {
        vm.headerTotals = [];
        vm.reportHeaders.forEach(function (header, index) {

            const columnTotals = vm.filteredReport.reduce(function (columnTotals, row) {
                columnTotals.total += row.Dates[index].Count;
                return columnTotals;
            }, { total: 0 });
            vm.headerTotals.push({ index: index, Total: columnTotals.total });
        });

        vm.reportTotal = vm.filteredReport.reduce(function (totals, data) {
            totals.Totals += data.Total;
            return totals;
        }, { Totals: 0 });
    }

    function filterTsuReport(data) {

        return (!vm.filters.OwnerName || containsInvariant(data.OwnerName, vm.filters.OwnerName))
            && (!vm.filters.EmployeeName || containsInvariant(data.EmployeeName, vm.filters.EmployeeName))
            && (!vm.filters.HireDate || moment(vm.filters.HireDate).isSame(data.HireDate))
            && (!vm.filters.StatusType || containsInvariant(data.StatusType, vm.filters.StatusType));
    }
}
